import { Hero } from '@swordhealth/ui-corporate';

import { RichText } from '@swordhealth/ui-corporate';

import { formattedTitle } from '@/utils/formatted-title';
import Media from './Media';
import { Wrapper } from './styles';

import useVideoTracking from '@/utils/useVideoTracking';

const HeroMedia = ({ content, userName }) => {
  const { media, mediaFit, mediaRatio } = content.media;
  const { description } = content.sectionHeader;

  const { ...trackVideo } = useVideoTracking({ src: media?.data?.attributes?.url });

  return (
    <Wrapper>
      <Hero
        {...content}
        sectionHeader={{
          ...content.sectionHeader,
          title: formattedTitle({ title: content.sectionHeader.title, userName }),
          descriptionAs: 'div',
          description: <RichText elements={['strong', 'br', 'p']}>{description}</RichText>,
        }}
        mediaRatio={mediaRatio || undefined}
        className={'hero-media'}
      >
        <Media
          {...media?.data?.attributes}
          objectFit={mediaFit}
          priority
          trackingProps={trackVideo}
        />
      </Hero>
    </Wrapper>
  );
};

HeroMedia.defaultConfig = {
  rounded: false,
  colored: true,
  spaceBottom: true,
  spaceTop: true,
  marginBottom: false,
  withGradient: false,
};

export default HeroMedia;
